import { Children, cloneElement, isValidElement, useId } from 'react';
import { Label } from '@/components/ui/label';

/* Label ist mit dem Feld verknüpft (htmlFor/id), damit Screenreader und Klick aufs Label funktionieren.
   Hat das Feld schon eine id, wird die genommen; sonst bekommt es eine (10.10.2026). */
export function FormField({ label, error, hint, required, children, className = '' }) {
  const autoId = useId();
  const kind = Children.count(children) === 1 && isValidElement(children) ? children : null;
  const feldId = kind ? (kind.props.id || autoId) : undefined;
  return (
    <div className={className}>
      {label && (
        <Label className="text-xs" htmlFor={feldId}>
          {label} {required && <span className="text-destructive">*</span>}
        </Label>
      )}
      {kind ? cloneElement(kind, { id: feldId }) : children}
      {hint && !error && <p className="text-[11px] text-muted-foreground mt-0.5">{hint}</p>}
      {error && <p className="text-[10px] text-destructive mt-0.5">{error}</p>}
    </div>
  );
}
